import { store } from "@store/index";
import { open as openSideNavigation } from "@store/features/layout/sideNavigationSlice";

export type PromoteScenariosKind = "agent" | "skill";

export type PromoteScenariosSidebarParams = {
  kind: PromoteScenariosKind;
  id: string;
  versionId: string;
  versionLabel: string;
};

type PromoteScenariosSidebarCallbacks = {
  onPromoted?: () => Promise<void> | void;
};

let callbacks: PromoteScenariosSidebarCallbacks = {};

export function openPromoteScenariosSidebar(
  params: PromoteScenariosSidebarParams,
  nextCallbacks?: PromoteScenariosSidebarCallbacks,
) {
  callbacks = nextCallbacks ?? {};
  store.dispatch(
    openSideNavigation({
      position: "right",
      schema: "PROMOTE_SCENARIOS",
      params,
      props: {
        width: "520px",
        mobileWidth: "90vw",
        runHandleClose: true,
      },
    }),
  );
}

export function consumePromoteScenariosCallback() {
  const cb = callbacks.onPromoted;
  callbacks = {};
  return cb;
}
